import { trpc } from "@/api/client";
import { Member } from "@/pages/SetupWorkflow/types";
import { useSelectedCompany } from "@flash-tecnologia/hros-web-utility";

type UseCreateEmployeeProps = {
  options?: {
    onError?: () => void;
  };
};

export const useCreateEmployees = ({ options }: UseCreateEmployeeProps) => {
  const { selectedCompany } = useSelectedCompany();
  const { mutateAsync, isLoading } = trpc.createEmployees.useMutation({
    onError: options?.onError,
  });

  const createEmployees = async (members: Member[]) => {
    const employeeResponse = await mutateAsync(
      members.map((member) => ({
        ...member,
        startDate: member.hiringDate?.toISOString(),
        companyId: selectedCompany.id,
      }))
    );

    return employeeResponse;
  };

  return {
    createEmployees,
    isLoading,
  };
};
